import { ethers } from "ethers";
import { message_portal } from "../addresses";
const message_abi = require("./abi.json");

export const { ethereum } = window;

export const _WalletGateContract = () => {
	if (ethereum) {
		const provider = new ethers.providers.Web3Provider(ethereum);
		const signer = provider.getSigner();
		const messagePortalContract = new ethers.Contract(
			message_portal,
			message_abi.abi,
			signer
		);

		return messagePortalContract;
	}
	return false;
};
